import React, { useId } from 'react';
import classNames from 'classnames';
import ChevronArrowIcon from '@/component/icon/ChevronArrowIcon';


interface SettingDisclosureProps {
    title: string;
    isOpen: boolean;
    onToggle: () => void;
    children: React.ReactNode;
}

const SettingDisclosure: React.FC<SettingDisclosureProps> = (props) => {
    const { title, children, isOpen, onToggle } = props;
    const panelId = useId();
    const titleId = useId();

    return (
        <div data-testid="setting-disclosure"
             className="scenario-setting-card flex flex-col"
        >
            <button className={classNames("disclosure-button", isOpen && "open")}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={onToggle}
            >
                <div id={titleId}
                     className="text-[14px] font-[600] text-black-500"
                >
                    {title}
                </div>
                <ChevronArrowIcon direction={isOpen ? "up" : "down"}
                                  className="size-4.5 transition-transform duration-200"
                />
            </button>
            <div id={panelId}
                 role="region"
                 aria-labelledby={titleId}
                 aria-hidden={!isOpen}
                 className={classNames(
                     "transition-disclosure px-6",
                     isOpen ? "open" : "closed"
                 )}
            >
                <div className="scenario-setting-card-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default SettingDisclosure;
